import { useState, createContext } from 'react';

type ItemFormContextType = {
  disableSubmit: boolean;
  setDisableSubmit: (value: boolean) => void;
};

const initialState = {
  disableSubmit: false,
  setDisableSubmit: () => {},
};

export const ItemFormContext = createContext<ItemFormContextType>(initialState);

export const useItemFormContext = (): ItemFormContextType => {
  const [disableSubmit, setDisableSubmit] = useState(initialState.disableSubmit);

  return {
    disableSubmit,
    setDisableSubmit,
  };
};
